import { NavItemState } from '../types/navItemState'

interface ItemStateProps {
  expanded?: boolean
  focused?: boolean
  hovered?: boolean
  readonly?: boolean
  selected?: boolean
  suggested?: boolean
}

export const getItemState = ({
  selected,
  focused,
  expanded,
  hovered,
  readonly,
  suggested,
}: ItemStateProps): NavItemState => {
  if (selected) {
    return 'selected'
  }

  if (hovered && !readonly) {
    return 'hovered'
  }

  if (suggested) {
    return 'suggested'
  }

  if (expanded) {
    return 'expanded'
  }

  if (focused) {
    return 'focused'
  }

  if (readonly) {
    return 'disabled'
  }

  return 'default'
}
